import { ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const currentLayout = window.$environment.CURRENT_LAYOUT;
const baseUrl = currentLayout === 'SpireonNew' ? '/spireon' : '';

const leftMenu = [
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.summary',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/summary',
  },
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.logs',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/logs',
  },
  {
    icon: mediaUrls.user,
    label: 'Drivers Status',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/driverStatus',
  },

  {
    icon: mediaUrls.inspections,
    label: 'leftMenu.inspections',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/inspections',
  },
  {
    icon: mediaUrls.reports,
    label: 'leftMenu.reports',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/report',
  },
  {
    icon: mediaUrls.policy,
    label: 'leftMenu.policiesProcedures',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/policy',
  },
];
export default leftMenu;
